<template>
  <div class="dashboard">
    <div class="dashboardpage">
      <div :class="`dash-second ${showFullAnswer && 'dash-border'} ${((showResponse && getQuestion && !isStudentPaced) || isLockPage) && 'red-dash-border'}`">
        <div :class="`dash-second-left ${!showFullAnswer && 'dash-border'}`" style="text-overflow: hidden">
          <p style="font-size: 1rem; font-weight: 600; padding: 20px 20px 0 20px;">
            Submitted <span class="correct" style="color: teal">{{ 100 - noAnswerPercentage }}%</span> | Not submitted
            <span class="incorrect" style="color: red">{{ noAnswerPercentage }}%</span>
          </p>
          <TeacherIndexItem v-if="getQuestion" :flag_1="true" :currentAnswerCount="currentAnswerCount" :textList="responseContentList" :isDash="true" />
        </div>
        <template v-if="getQuestion && getQuestion.type !== 'website'">
          <!-- <div v-if="!showFullAnswer" class="dash-second-right">
            <DashResAndStudents :showResponse="showResponse" :responseList="responseContentList" />
          </div> -->
          <div :class="`dash-second-right dash-students dash-pad-students ${padTab === 2 && 'dash-pad-hidden'}`">
            <DashGroupStudents />
          </div>
        </template>
        <!-- <DashSwitchHeader :showResponse="showResponse" :padTab="padTab" :changePadTab="changePadTab" v-if="getQuestion && getQuestion.type !== 'website'" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import DashResAndStudents from '../../dashResAndStudents.vue'
import PptDetail from '@/components/pptDetail.vue'
import DashGroupStudents from '../../dashGroupStudents.vue'
import DashSwitchHeader from '../../dash/dashSwitchHeader.vue'
import DashboardMeterial from '../../dashboardMeterial.vue'
import TeacherIndexItem from '../../Index.vue'
import DashTopPptList from '../../dash/dashTopPptList.vue'
export default {
  components: {DashSwitchHeader, TeacherIndexItem, DashboardMeterial, DashResAndStudents, DashTopPptList, DashGroupStudents, PptDetail},
  props: {
    currentAnswerCount: {
      type: Number,
      default: 0,
    },
    responseContentList: {
      type: Array,
      function() {
        return []
      },
    },
    responsePercentage: {
      type: Array,
      function() {
        return []
      },
    },
    overviewModalVisiable: {
      type: Boolean,
      default: false,
    },
    changePage: {
      type: Function,
    },
    maxStudentCount: {
      type: Number,
    },
  },
  data() {
    return {
      height: window.winHeight,
      //   showPPTList: true,
      //   isVideoFeedback: true,
      padTab: 2,
      maxStud: 0,
    }
  },
  computed: {
    ...mapState('teacher', ['rooms']),
    ...mapState({
      currentPageIndex: (state) => state.student.currentPageIndex,
    }),
    ...mapGetters(['isStudentPaced', 'getQuestion']),
    ...mapGetters('student', ['currentVideoQuizAnswerList']),
    showFullAnswer() {
      return this.$store.state.teacher.showMoreMap[this.currentPageIndex] ?? false
    },
    showResponse() {
      return this.$store.getters['teacher/isResponseShow'](this.currentPageIndex)
    },
    isLockPage() {
      return this.$store.getters['teacher/isLocked'](this.currentPageIndex)
    },
    tpClass() {
      return this.showResponse && this.getQuestion.type !== 'website' && !this.isStudentPaced ? 'content_parent content_parent--border' : 'content_parent'
    },
    noAnswerPercentage() {
      const studentTotalCount = this.maxStudentCount
      this.maxStud = Math.max(studentTotalCount, this.maxStud)
      const currentAnswers = this.currentVideoQuizAnswerList
      const uniqueUids = new Set(currentAnswers.map((item) => item.uid))


      if (this.maxStud === 0) return 100
      const noAnswers = this.maxStud - uniqueUids.size
      if (noAnswers <= 0) return 0
      return ((noAnswers / this.maxStud) * 100).toFixed(0)
    },
  },
  created() {},
  mounted() {
  },
  methods: {
    showCurrentStudent() {
    },
    changePadTab(index) {
      this.padTab = index
    },
  },
}
</script>

<style scoped>
@import url(../../../../assets/css/dashpage.css);
.red-dash-border {
  border: none;
}

.dashboard {
  height: 82%;
}

@media screen and (max-height: 600px) {
  .dashboard {
    height: 75%;
  }
}

</style>
